import { __rest } from "tslib";
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import React, { useState, useMemo } from 'react';
import zhCN from 'date-fns/locale/zh-CN';
import moment, { isMoment } from 'moment';
import { Input } from 'antd';
import classNames from 'classnames';
import styles from './schedule_date_picker.module.scss';
import { getIn18Text } from 'api';
registerLocale('zhCN', zhCN);
setDefaultLocale('zhCN');
export const CustomDatePickerInput = React.forwardRef((props, ref) => React.createElement(Input, Object.assign({ ref: ref }, props)));
const customHeader = ({ date, decreaseMonth, increaseMonth, }) => (React.createElement("div", { className: `${styles.header} schedule-date-picker-header` },
    React.createElement("i", { onClick: decreaseMonth, className: classNames(styles.arrow, 'arrow', styles.left, 'left') }),
    React.createElement("span", { className: styles.dater }, moment(date).format(getIn18Text('yyyyNIAN'))),
    React.createElement("i", { onClick: increaseMonth, className: classNames(styles.arrow, 'arrow', styles.right, 'right') })));
const PreSetDatePicker = props => {
    const { dateFormat = 'yyyy-MM-dd', onChange, value, style, allowClear = true, className, filterDate, onKeyDown, popperStrategy, offset } = props, rest = __rest(props, ["dateFormat", "onChange", "value", "style", "allowClear", "className", "filterDate", "onKeyDown", "popperStrategy", "offset"]);
    const [date, setDate] = useState(moment.isMoment(value) ? value.toDate() : undefined);
    const dateChange = (d) => {
        if (offset === undefined) {
            if (onChange) {
                onChange(d ? moment(d) : null);
            }
        }
        else {
            const localDate = new Date();
            const localOffset = localDate.getTimezoneOffset();
            const targetTime = d ? new Date(d.getTime() + (-localOffset - offset) * 60000) : null;
            if (onChange) {
                onChange(targetTime ? moment(targetTime) : null);
            }
        }
        setDate(d);
    };
    const selected = useMemo(() => {
        if (offset === undefined) {
            return isMoment(value) ? value.toDate() : date;
        }
        else {
            const localDate = new Date();
            const localOffset = localDate.getTimezoneOffset();
            const originDate = isMoment(value) ? value.toDate() : date;
            const targetTime = originDate ? new Date(originDate.getTime() + (offset + localOffset) * 60000) : undefined;
            return targetTime;
        }
    }, [offset, value, date]);
    return (React.createElement("div", { className: styles.reactDatepickerWrapper },
        React.createElement(DatePicker, Object.assign({ onChange: dateChange, selected: selected, closeOnScroll: () => true, filterDate: filterDate, onKeyDown: onKeyDown }, rest, { placeholderText: rest.placeholder, locale: "zhCN", dateFormat: dateFormat, showPopperArrow: false, customInput: React.createElement(CustomDatePickerInput, { disabled: rest.disabled, className: className, style: style }), popperProps: { strategy: popperStrategy }, popperModifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        altAxis: true,
                    },
                },
                {
                    name: 'flip',
                    options: {
                        altBoundary: true,
                    },
                },
            ], isClearable: isMoment(value) && allowClear && !rest.disabled, renderCustomHeader: customHeader }))));
};
export default PreSetDatePicker;
